import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ISettings } from '../_models/ISettings';
import { AppComponent } from 'app/app.component';
import { DialogHeaderComponent } from 'app/dialog-header-component/dialog-header.component';
import { IconDefinition, faGear, faSliders, faBorderAll, faUser, faInfoCircle, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { CommunicationService } from 'app/_services/communication.service';

@Component({
  selector: 'settings-component',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  //#region Fields & Icons
  @Input() settings: ISettings;
  @Input() mobileView: boolean = false;
  @ViewChild(DialogHeaderComponent) dialogHeader: DialogHeaderComponent;
  selectedItem: number = 1;
  faGear: IconDefinition = faGear;
  faSliders: IconDefinition = faSliders;
  faBorderAll: IconDefinition = faBorderAll;
  faUser: IconDefinition = faUser;
  faInfoCircle: IconDefinition = faInfoCircle;
  faArrowUpRightFromSquare: IconDefinition = faArrowUpRightFromSquare;
  //#endregion

  constructor(
    public app: AppComponent,
    private communicationService: CommunicationService 
  ) { }

  ngOnInit(): void { }

  updateDarkModeSetting(value: any): void {
    this.settings.darkModeSetting = value;
    this.settings.followSystemDarkMode = false;
    localStorage.removeItem('qx_setting_matchSystemDarkMode');
    if (value) localStorage.setItem('qx_setting_darkMode', value);
    else localStorage.removeItem('qx_setting_darkMode');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  followSystem(event: any): void {
    if (event.checked) {
      this.settings.darkModeSetting = window.matchMedia('(prefers-color-scheme: dark)').matches;
      localStorage.setItem('qx_setting_matchSystemDarkMode', 'true');
    } else localStorage.removeItem('qx_setting_matchSystemDarkMode');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateMenuToggleSetting(value: any): void {
    this.settings.menuToggleSetting = value;
    if (!value) localStorage.setItem('qx_setting_menuToggle', value);
    else localStorage.removeItem('qx_setting_menuToggle');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateTextSizeSetting(value: any): void {
    this.settings.textSizeSetting = value;
    localStorage.setItem('qx_setting_textSize', value);
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateDetailedErrorSetting(value: any): void {
    this.settings.detailedErrorSetting = value;
    if (value) localStorage.setItem('qx_setting_detailedErrors', value);
    else localStorage.removeItem('qx_setting_detailedErrors');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateDateFormatSetting(event: any): void {
    this.removeFiltersFromStorage();
    this.settings.dateFormatSetting = event.srcElement.value.toString();
    localStorage.setItem('qx_setting_dateFormat', event.srcElement.value.toString());
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateCompactGridSetting(value: any): void {
    this.settings.compactGridSetting = value;
    if (value) localStorage.setItem('qx_setting_compactGrid', value);
    else localStorage.removeItem('qx_setting_compactGrid');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateFiltersByRowSetting(value: any): void {
    this.removeFiltersFromStorage();
    this.settings.detailFiltersByRowSetting = value;
    if (value) localStorage.setItem('qx_setting_detailFiltersByRow', value);
    else localStorage.removeItem('qx_setting_detailFiltersByRow');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateFilterHistorySetting(value: any): void {
    this.removeFiltersFromStorage();
    this.settings.filterHistorySetting = value;
    if (!value) localStorage.setItem('qx_setting_filterHistory', value);
    else localStorage.removeItem('qx_setting_filterHistory');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateFilterDelaySetting(value: any): void {    
    this.settings.filterDelaySetting = value;
    if (value) localStorage.setItem('qx_setting_filterDelay', value);
    else localStorage.removeItem('qx_setting_filterDelay');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateFreeColumnResizeSetting(value: any): void {    
    this.settings.freeColumnResizeSetting = value;
    if (value) localStorage.setItem('qx_setting_freeColumnResize', value);          
    else localStorage.removeItem('qx_setting_freeColumnResize');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateTextAlignmentSetting(value: any): void {    
    this.settings.textAlignmentSetting = value;
    if (value) localStorage.setItem('qx_setting_textAlignment', value);          
    else localStorage.removeItem('qx_setting_textAlignment');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateStickyDetailHeadersSetting(value: any): void {
    this.settings.stickyDetailHeadersSetting = value;
    if (!value) localStorage.setItem('qx_setting_stickyDetailHeaders', value);          
    else localStorage.removeItem('qx_setting_stickyDetailHeaders');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  updateWidgetsOpenSetting(value: any): void {
    this.settings.widgetsOpen = value;
    if (value) localStorage.setItem('qx_setting_widgetsOpen', value);          
    else localStorage.removeItem('qx_setting_widgetsOpen');
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }

  changePassword(): void {
    sessionStorage.setItem('resetPassword', 'true');
    this.app.router.navigate(['signin']);
  }

  removeFiltersFromStorage(): void {
    for (let key in localStorage) {
      if (localStorage.hasOwnProperty(key) && key.includes('qx_filters'))
        localStorage.removeItem(key);
    }
  }

  selectItem(item: number): void {
    this.selectedItem = item;
  }

  openStorageManagement(): void {
    this.communicationService.showStorageManagementDialog();
    if (this.dialogHeader) this.dialogHeader.hardRefresh = true;
  }    
}
